import Alert from 'antd/lib/alert';
import React from 'react';
import './ErrorAlertStyles.css';

const ErrorAlert: React.FC<any> = props => (
  <div className="alert-wrapper">
    <Alert {...props} type="error" />
  </div>
);

export default ErrorAlert;



// WEBPACK FOOTER //
// ./src/components/ErrorAlert/ErrorAlert.tsx